import { GeneralInputProps } from "@/models/props/TextInput";
import { Select } from "@radix-ui/themes";
import React, { FocusEventHandler, FormEventHandler, useState } from "react";
import slugify from "react-slugify";

const SelectInput: React.FunctionComponent<
  GeneralInputProps & {
    options?: { text: string | number; value: string | number }[];
    onChange?: FormEventHandler<HTMLSelectElement>;
    onBlur?: FocusEventHandler<HTMLSelectElement>;
    children: any;
    setDataId?: any;
  }
> = ({
  name,
  value,
  onChange,
  onBlur,
  styleProps,
  placeholder,
  options,
  children,
  isDisabled,
  setDataId,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>();

  return (
    <Select.Root
      defaultValue={value === undefined ? " " : value}
      name={name}
      onValueChange={() => {
        onChange;
        setIsOpen(!isOpen);
      }}
      disabled={isDisabled}
    >
      <Select.Trigger />

      <Select.Content>
        {!children &&
          options &&
          options.map((element) => {
            const value = element.value === "" ? " " : element.value;
            const key = slugify(element.text);

            return (
              <Select.Item key={key} value={value.toString()}>
                {element.text}
              </Select.Item>
            );
          })}
        {children && !options && children}
      </Select.Content>
    </Select.Root>
  );
};

export default SelectInput;
